import {Component, Inject, Input, OnChanges, OnInit, ViewChild} from '@angular/core';
import {ConfService} from '../conf.service';
import {LeftpanelComponent, LoaderWithProgressComponent, ScheduleJobDialogComponent} from '../leftpanel/leftpanel.component';
import {Router} from '@angular/router';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {DataService} from './er-diagram/service/data.service';
import {ConnecttocrudService} from '../connecttocrud.service';
import {ListenerService} from '../listener.service';
import {KongService} from '../kong.service';
import {NgForm} from '@angular/forms';
import {DatacatalogListenerService} from '../datacatalog-listener.service';
import {AccountInfoService} from '../user/account-info.service';

@Component({
    selector: 'app-data-catalogue',
    templateUrl: './data-catalogue.component.html',
    styleUrls: ['./data-catalogue.component.scss']
})
export class DataCatalogueComponent implements OnInit, OnChanges {

    @Input() partner = localStorage.getItem('partner');
    @Input() account = localStorage.getItem('account');
    @Input() pkey = localStorage.getItem('partnerKey');
    @Input() databaseName: string;
    @Input() databaseConnectionName: any;
    @Input() tableName: string;
    @Input() selectedDatabaseConnectionObject: any;
    @Input() databaseERProperties: any;
    @Input() objectToRender: any;
    @Input() listOfTablesInADatabase: any;
    @Input() databaseErDataLoading: any;
    @Input() currentParentTab: any;
    @Input() resObj: any;
    @Input() viewObject: any;
    @Input() listOfTables = [];

    loaderDialog: any;

    erTables = [];
    relations = [];
    erFlag: boolean;

    propertiesLoading: boolean;
    dataLoading: boolean;
    ERLoading: boolean;
    ERDiagramLoading = false;


    filterData: any[];
    settings = {text: 'Select attribute(s) to search instantly'};
    itemList: any[];
    searchText: any;
    error = false;
    items: any;
    userView = 'table';
    columns: string[] = [];
    columns1: string[] = [];
    options: any;
    itemLength: any;
    errorMessage: string;
    databaseConnections = [];
    databases: any;
    tables: any;
    tableResponse: any = [];
    metaSchema: any;
    foreignKeys: any;
    references: any;
    indexesTable: any;
    indexesTableKeySet: any;
    triggersTable: any;
    triggersTableKeySet: any;
    dbPropertiesLoading = false;
    resObjkeys: any;
    tableProperties = true;

    data: any;
    dataErrorMessage: string;
    schemaColumns = ['NAME', 'TYPE', 'SIZE', 'KEY', 'AUTO INCREMENT'];
    propertiesElements = [
        {name: 'Tables', iconName: 'fa fa-table'},
        {name: 'Views', iconName: 'fa fa-eye'},
        {name: 'Procedures', iconName: 'fa fa-tasks'},
        {name: 'Triggers', iconName: 'fa fa-bolt'},
        {name: 'Events', iconName: 'fa fa-calendar'}
    ];

    viewResponse: any;
    procedureReponse: any;
    triggerResponse: any;
    indexResponse: any;
    viewResponseLoading = true;
    procedureReponseLoading = true;
    triggerResponseLoading = true;
    indexResponseLoading = true;
    newDataDictionaryPayload = {
        partner: '',
        account: '',
        database_connection_name: '',
        database_name: '',
        database_description: '',
        table_name: '',
        table_description: '',
        columns: [],
        foreign_keys: [],
        references: []
    };
    dataDictionaryData: any;
    dataDictionaryError = '';
    isDataDictionaryFound: boolean;
    dataDictionaryId: number;

    lineageFlag = false;
    lineagePathTable: any;
    lineagePathDataLoading = true;

    lineagePathDiagramLoading = true;
    currentParentTabDisplayed: string;
    dbObjectResponse: any;
    dbObjectLoading = true;
    currentChildTab: string = 'Catalog';
    currentTab: string;
    databaseERDiagramLoading = false;
    catalogFlag = true;

    listofTables: any;
    listofViews: any;
    listofProcedures: any;
    listofIndexes: any;
    useReferentialKeys: boolean;
    targetDatabase: any;
    @ViewChild('myForm1', {static: false}) public MyForm1: NgForm;
    selectedDatatypeFilter: any;
    targetDatabaseType: any;
    transformOptionSelected: any;
    transformOptions = [
        {
            'name': 'Generate APIs Only - No Data Migration',
            'value': 'apionly',
            'disabled': false
        },
        {
            'name': 'Migrate Data Only - No API Generation',
            'value': 'dataonly',
            'disabled': true
        },
        {
            'name': 'Migrate Data & Generate APIs',
            'value': 'apiwithdata',
            'disabled': false
        }
    ];

    referentialKeyOptions = [
        // {'value': 'embed',
        //  'display_name': 'Embed child data with parent entity'},
        {
            'value': 'reference',
            'display_name': 'Seperate data and create reference'
        }
    ];
    referentialKeyOptionSelected = 'reference';

    dataMigration = false;
    deploymentPlan: any;
    apiExecutorPlans: any;
    entityPlans: any;
    dataMigrationPlans: any;
    showNextPanel = false;
    progress = 0;
    progressMessage: string;
    databaseObjectTypes: any;
    selectedDatabaseObjectTypes: any;
    databaseObjectTypeFilter = [{type: 'tables', display_name: 'Tables'}, {type: 'views', display_name: 'Views'}, {
        type: 'procedures',
        display_name: 'Procedures'
    },
        {type: 'indexes', display_name: 'Indexes'}, {type: 'triggers', display_name: 'Triggers'}];

    showDeploymentPlanFlag = true;
    cascadeOnDelete = true;
    cascadeOnUpdate = true;
    loading = false;
    loading1 = false;
    buildDeploymentRetries = 0;
    componentLoading = true;
    generateDaaChecked = true;
    migrateDaaChecked = true;
    deploymentPlanToPost: any;


    totalPages: any;
    currentPage: any;
    currentOffset = 0;
    limit = 20;
    table: any;
    collectionSize: any;
    page = 1;
    currentPageDisplayed = 1;
    itemsPerPage = 20;
    selectedItemsPerPageIndex = 2;

    nodeSelected(node) {
    }

    constructor(public confPost: ConfService,
                public platform: LeftpanelComponent,
                public router: Router,
                public dialog: MatDialog,
                public dataService: DataService,
                public _service: ConnecttocrudService,
                public accountInfoService: AccountInfoService,
                public listenerInstance: ListenerService,
                public dataCatalogListenerInstance: DatacatalogListenerService) {
    }

    async ngOnInit() {
        // this.newDataDictionaryPayload.partner = this.partner;
        // this.newDataDictionaryPayload.account = this.account;
        // if (this.platform.databases !== null && this.platform.databases !== undefined) {
        //   this.getSQLDatabases(this.platform.databases);
        // } else {
        //   await this.platform.getDatabasesForPartnerAccount();
        //   if (this.platform.databases) {
        //     this.getSQLDatabases(this.platform.databases);
        //   }
        // }
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }
        if (this.platform.databases === null || this.platform.databases === undefined || !this.platform.databases) {
            await this.platform.getDatabasesForPartnerAccount();
        }
        this.databases = this.platform.databases;
        if (this.data) {
            this.databaseName = this.data['databaseName'];
        }
        this.erFlag = false;
        if (this.objectToRender === 'table' || this.objectToRender === 'database') {
            this.getTableInfo();
            this.refreshErDiagram();
        }

        if (this.resObj) {
            this.resObjkeys = Object.keys(this.resObj);
        }
        if (this.platform.databaseObjectTypes && this.platform.databaseObjectTypes !== null && this.platform.databaseObjectTypes !== undefined) {
            this.databaseObjectTypes = this.platform.databaseObjectTypes;
        } else {
            await this.platform.getDatabaseObjectTypes();
            this.databaseObjectTypes = this.platform.databaseObjectTypes;
            if (this.platform.databaseObjectTypes === undefined || this.platform.databaseObjectTypes === null) {
                this.platform.openSnackBar('Error while fetching databases. Please try again after sometime.', 'Error', {
                    duration: 15000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        }
        // this.filterDatabaseObjectTypes();
    }

    ngOnChanges() {
        this.currentParentTabDisplayed = this.currentParentTab;
        if (this.currentParentTabDisplayed === this.tableName) { //|| this.currentParentTabDisplayed === this.databaseName) {
            setTimeout(() => {
                this.lineagePathDiagramLoading = false;
                this.ERDiagramLoading = false;
            }, 500);

        } else {
            this.lineagePathDiagramLoading = true;
            this.ERDiagramLoading = true;
        }
        if (this.objectToRender === 'database' && this.currentParentTabDisplayed === this.databaseName) {
            setTimeout(() => {
                this.databaseERDiagramLoading = false;
            }, 500);
        } else {
            this.databaseERDiagramLoading = true;
        }
    }

    deployAsAPI() {
        const dialogRef = this.dialog.open(DeployAsAPIComponent, {
            width: '90vw',
            height: 'auto',
            data: {
                databaseConnectionName: this.databaseConnectionName,
                databaseName: this.databaseName,
                tableName: this.listOfTables
            }
        });

        dialogRef.afterClosed().subscribe(async response => {
        });
    }

    getTableInfo() {
        this.newDataDictionaryPayload.partner = this.partner;
        this.newDataDictionaryPayload.account = this.account;
        // const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
        //   maxWidth: '95vw',
        //   maxHeight: '60vh',
        // });
        this.dataDictionaryError = '';
        this.getProperties(this.tableName, this.databaseName, this.selectedDatabaseConnectionObject[0]['database_type'], this.selectedDatabaseConnectionObject[0]['database_name']);
        if (this.objectToRender === 'table') {
            this.getData(this.tableName, this.databaseName, this.selectedDatabaseConnectionObject[0]['database_type'], this.selectedDatabaseConnectionObject[0]['database_name'], this.limit, this.currentOffset);
        }

    }

    getViewsDetails() {
        if (!this.viewResponse) {
            const payload = {
                'databaseConnectionName': this.databaseConnectionName,
                'databaseObjects': ['views'],
                'databaseName': this.databaseName
            };
            this.confPost.getEntireSchemaForPartnerDatabase(this.partner, payload).subscribe(response => {
                if (response) {
                    this.viewResponseLoading = false;
                    this.viewResponse = response['views'];
                } else {
                    this.platform.openSnackBar('No Response Present', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.viewResponse = [];
                    this.viewResponseLoading = false;
                }
            }, error => {
                this.platform.openSnackBar('No Response Present', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.viewResponse = [];
                this.viewResponseLoading = false;
            });
        }

    }

    getIndexDetails() {
        if (!this.indexResponse) {
            const payload = {
                'databaseConnectionName': this.databaseConnectionName,
                'databaseObjects': ['indexes'],
                'databaseName': this.databaseName
            };
            this.confPost.getEntireSchemaForPartnerDatabase(this.partner, payload).subscribe(response => {
                if (response) {
                    this.indexResponseLoading = false;
                    this.indexResponse = response;
                    let ress = [];
                    if (this.databaseName === 'postgres') {
                        for (let i = 0; i < this.indexResponse['indexes'].length; i++) {
                            if (this.indexResponse['indexes'][i]['index_name'] !== null) {
                                ress.push(this.indexResponse['indexes'][i]);
                            }
                        }
                    } else {
                        for (let i = 0; i < this.indexResponse['indexes'].length; i++) {
                            if (this.indexResponse['indexes'][i]['index_name'] !== null) {
                                ress.push(this.indexResponse['indexes'][i]);
                            }
                        }
                    }

                    this.indexResponse = ress;
                } else {
                    this.platform.openSnackBar('No Response Present', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.indexResponse = [];
                    this.indexResponseLoading = false;
                }
            }, error => {
                this.platform.openSnackBar('No Response Present', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.indexResponseLoading = false;
                this.indexResponse = [];
            });
        }
    }

    getTriggerDetails() {
        if (!this.triggerResponse) {
            const payload = {
                'databaseConnectionName': this.databaseConnectionName,
                'databaseObjects': ['triggers'],
                'databaseName': this.databaseName
            };
            this.confPost.getEntireSchemaForPartnerDatabase(this.partner, payload).subscribe(response => {
                if (response) {
                    this.triggerResponseLoading = false;
                    this.triggerResponse = response['triggers'];
                } else {
                    this.platform.openSnackBar('No Response Present', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.triggerResponseLoading = false;
                    this.triggerResponse = [];
                }
            }, error => {
                this.platform.openSnackBar('No Response Present', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.triggerResponseLoading = false;
                this.triggerResponse = [];
            });
        }
    }

    getProcedureDetails() {
        if (!this.procedureReponse) {
            const payload = {
                'databaseConnectionName': this.databaseConnectionName,
                'databaseObjects': ['procedures'],
                'databaseName': this.databaseName
            };
            this.confPost.getEntireSchemaForPartnerDatabase(this.partner, payload).subscribe(response => {
                if (response) {
                    this.procedureReponseLoading = false;
                    this.procedureReponse = response['procedures'];
                } else {
                    this.platform.openSnackBar('No Response Present', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.procedureReponse = [];
                    this.procedureReponseLoading = false;
                }
            }, error => {
                this.platform.openSnackBar('No Response Present', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.procedureReponse = [];
                this.procedureReponseLoading = false;
            });
        }
    }

    loadErDiagramData(tables) {
        let tempResponse = [];
        for (const table of tables) {
            this.confPost.getPropertiesOfTable(this.partner, this.selectedDatabaseConnectionObject[0]['database_type'], this.selectedDatabaseConnectionObject[0]['database_name'], this.databaseName, table).subscribe(response => {
                if (response) {
                    tempResponse.push(response);
                    if (response.hasOwnProperty('columns')) {
                        const temp = {
                            tableName: table,
                            foreignKeys: response['foreignKeys'],
                            references: response['references'],
                            fields: response['columns']
                        };
                        if (response['foreignKeys'].length > 0 || response['references'].length > 0) {
                            this.relations.push(temp);
                        } else {
                            this.erTables.push(temp);
                        }
                    }
                }

                if (tables.length === tempResponse.length) {
                    this.ERLoading = false;
                    //this.erFlag = true;
                }
            }, error => {
                tempResponse.push(error);
                this.ERLoading = false;
            });
        }

        this.databaseERProperties['erTables'] = this.erTables;
        this.databaseERProperties['relations'] = this.relations;
    }


    async refreshErDiagram() {
        //this.dataService.clearData();
        this.ERLoading = true;
        this.dbPropertiesLoading = true;
        this.tables = [];
        this.erTables = [];
        this.relations = [];
        if (this.objectToRender !== 'table') {

            this.confPost.getDatabaseTablesForAConnection(this.partner, this.selectedDatabaseConnectionObject[0]['database_name'], this.selectedDatabaseConnectionObject[0]['database_type'], this.databaseName).subscribe(res => {
                if (res) {
                    this.tableResponse = res;
                    if (this.objectToRender === 'database') {
                        this.listOfTables = this.tableResponse;
                    }
                    this.dbPropertiesLoading = false;
                    this.generateDeploymentPlanToPost();
                    this.loadErDiagramData(res);
                } else {
                    this.ERLoading = false;
                }
            }, error => {
                this.ERLoading = false;
            });

            //this.erTables = this.databaseERProperties['erTables'];
            //this.relations = this.databaseERProperties['relations'];
            //this.erFlag = true;

        } else {
            if (this.objectToRender === 'table') {
                this.listOfTables = [this.tableName];
            }
            this.tables.push(this.tableName);
            this.confPost.getPropertiesOfTable(this.partner, this.selectedDatabaseConnectionObject[0]['database_type'], this.selectedDatabaseConnectionObject[0]['database_name'], this.databaseName, this.tableName).subscribe(response => {
                if (response) {
                    if (response['foreignKeys'].length > 0) {
                        for (const relation of response['foreignKeys']) {
                            this.tables.push(relation['PKTABLE_NAME']);
                        }
                    }
                }

                this.loadErDiagramData(this.tables);
                //this.erFlag = true;
            }, error => {
                this.ERLoading = false;
            });
        }

    }

    generateDeploymentPlanToPost() {
        this.deploymentPlanToPost = {};
        let tablePlan = {};
        for (const table of this.tableResponse) {
            tablePlan[table] = {
                generateAPIs: true,
                migrateData: true,
                targetDatabase: ''
            };
        }
        this.deploymentPlanToPost['tables'] = tablePlan;
    }

    databaseTabChanged(data) {
        if (data.tab.textLabel === 'ER Diagram') {
            setTimeout(() => {
                this.erFlag = true;
            }, 500);
        } else {
            this.erFlag = false;
        }
    }

    catalogueTabChanged(data) {
        this.currentTab = data.tab.textLabel;
        if (this.currentTab === 'ER Diagram') {
            setTimeout(() => {
                this.erFlag = true;
            }, 500);
        } else {
            this.erFlag = false;
        }
    }

    catalogueParentTabChanged(data) {
        this.currentChildTab = data.tab.textLabel;
        if (this.currentChildTab === 'Lineage Path') {
            setTimeout(() => {
                this.lineageFlag = true;
            }, 500);
        } else {
            this.lineageFlag = false;
        }
        if (this.currentChildTab === 'ER Diagram') {
            setTimeout(() => {
                this.catalogFlag = true;
                this.erFlag = true;
            }, 500);
        } else {
            this.catalogFlag = false;
            this.erFlag = false;
        }
    }

    getTablesForADatabase(event) {
        this.tableName = '';
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
        });
        this.confPost.getDatabaseTablesForAConnection(this.partner, this.selectedDatabaseConnectionObject[0]['database_name'], this.selectedDatabaseConnectionObject[0]['database_type'], event['value']).subscribe(response => {
            loaderDialog.close();
            if (response) {
                this.tables = response;
                this.refreshErDiagram();
            } else {
                this.platform.openSnackBar('Error while fetching tables. Please try again after sometime.', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.ERLoading = false;
            }
        }, error => {
            loaderDialog.close();
            this.ERLoading = false;
            this.platform.handleErrorGracefully(error, 'Error while fetching tables. Please try again after sometime.');
        });
    }

    getDatabasesForConnection(event) {
        this.tableName = '';
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
        });
        this.selectedDatabaseConnectionObject = this.databaseConnections.filter((element) => element['database_name'] === event['value']);
        this.confPost.getDatabasesForAConnection(this.partner, this.selectedDatabaseConnectionObject[0]['database_name'], this.selectedDatabaseConnectionObject[0]['database_type']).subscribe(response => {
            loaderDialog.close();
            if (response) {
                this.databases = response;
            } else {
                this.platform.openSnackBar('Error while fetching databases. Please try again after sometime.', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        }, error => {
            loaderDialog.close();
            this.platform.handleErrorGracefully(error, 'Error while fetching databases. Please try again after sometime.');
        });
    }

    checkFilter() {
        if (!this.filterData || this.filterData === [] || this.filterData === null) {
            alert('Please select an attribute to filter.');
            this.searchText = '';
        }
    }

    typeOfval(val) {
        return typeof val;
    }

    stringifyjson(val) {
        return JSON.stringify(val, null, 2).trim();
    }

    getData(tableName, databaseName, databaseType, databaseConnectionName, limit, offset) {
        this.dataLoading = true;
        this.confPost.getDataOfADatabaseTable(this.partner, databaseType, databaseConnectionName, databaseName, tableName, limit, offset).subscribe(response => {
            this.dataLoading = false;
            if (response && response[0] && response[0].hasOwnProperty('data')) {
                this.items = response[0]['data'];
                this.currentPage = response[0]['_pages']['current'];
                this.totalPages = response[0]['_pages']['total'];
                this.collectionSize = response[0]['_pages']['totalRows'];
                this.currentOffset = 0;
                if (this.items && this.items.length > 0) {
                    const tempItems = [];
                    const tempArray = Object.keys(this.items[0]);
                    for (const item of this.items) {
                        const tempObject = {};
                        for (const field of tempArray) {
                            if (field && field !== null && field !== undefined) {
                                for (const itemField of Object.keys(item)) {
                                    if (itemField.toLowerCase() === field.toLowerCase()) {
                                        tempObject[itemField] = item[itemField];
                                    }
                                }
                            }
                        }
                        tempItems.push(tempObject);
                    }
                    this.items = tempItems;
                    if (this.items && this.items !== null && this.items !== undefined) {
                        for (const item of this.items) {
                            this.columns = [];
                            this.columns1 = [];
                            for (const itemval in item) {
                                this.columns.push(itemval);
                                this.columns1.push(itemval);
                            }
                        }
                    }
                    if (tempArray) {
                        for (let i = 0; i < tempArray.length; i++) {
                            for (let j = 0; j < this.columns.length; j++) {
                                if (tempArray[i] === this.columns[j]) {
                                    if (tempArray[i]) {
                                        this.columns1[j] = tempArray[i];
                                    }
                                }
                            }
                        }
                    }
                    this.itemList = [];
                    for (let t = 0; t < this.columns.length; t++) {
                        const tempObj = {};
                        tempObj['id'] = t;
                        tempObj['itemName'] = this.columns[t];
                        this.itemList.push(tempObj);
                    }
                    this.options = {
                        fieldSeparator: ',',
                        quoteStrings: '',
                        decimalseparator: '.',
                        headers: this.columns,
                        showTitle: false,
                        useBom: true,
                        noDownload: false,
                        nullToEmptyString: true,
                        removeNewLines: false,
                        keys: []
                    };
                }
            }
        }, error => {
            if (error) {
                if (error.error) {
                    this.dataErrorMessage = error.error.message ? error.error.message : error.error;
                } else {
                    this.dataErrorMessage = 'Oops!!! Something went wrong. Data not found...';
                }
            } else {
                this.dataErrorMessage = 'Oops!!! Something went wrong. Data not found...';
            }
            // this.platform.handleErrorGracefully(error, 'Something went wrong while retrieving data. Please try again sometime.');
            this.dataLoading = false;
        });
    }


    lastPage() {
        this.currentOffset = (this.page - 1) * this.itemsPerPage;
        this.limit = this.itemsPerPage;
        this.getPaginatedData();
        this.currentPageDisplayed = 1;
    }

    getPageSymbol(current: number) {
        return [10, 20, 40, 60, 100][current - 1];
    }

    setItemsPerPage() {
        switch (this.selectedItemsPerPageIndex) {
            case 1:
                this.itemsPerPage = 10;
                break;
            case 2:
                this.itemsPerPage = 20;
                break;
            case 3:
                this.itemsPerPage = 40;
                break;
            case 4:
                this.itemsPerPage = 60;
                break;
            case 5:
                this.itemsPerPage = 100;
                break;
            default:
                this.itemsPerPage = 20;
        }
        this.lastPage();
    }

    getPaginatedData() {
        this.getData(this.tableName, this.databaseName, this.selectedDatabaseConnectionObject[0]['database_type'], this.selectedDatabaseConnectionObject[0]['database_name'], this.limit, this.currentOffset);
    }

    generateTable(val) {
        this.listenerInstance.generateTableFromChild.emit({
            tableName: val,
            databaseName: this.databaseName,
            databaseConnectionName: this.databaseConnectionName,
            selectedDatabaseConnectionObject: this.selectedDatabaseConnectionObject
        });
    }

    generateObj(val, type, obj) {
        if (type === 'views') {
            this.listenerInstance.generateObjFromChild.emit({
                objName: val,
                databaseName: this.databaseName,
                resObj: obj,
                dbType: type,
                databaseConnectionName: this.databaseConnectionName,
                selectedDatabaseConnectionObject: this.selectedDatabaseConnectionObject
            });
        } else {
            this.listenerInstance.generateObjFromChild.emit({
                objName: val,
                databaseName: this.databaseName,
                resObj: obj,
                dbType: type,
                databaseConnectionName: this.databaseConnectionName,
                selectedDatabaseConnectionObject: this.selectedDatabaseConnectionObject
            });
        }
    }

    refresh() {
        this.showNextPanel = false;
        this.showDeploymentPlanFlag = true;
    }

    getDataDictionaryData() {
        return new Promise((resolve, reject) => {
            this.confPost.getData('services', 'services', 'v1', 'datadictionary', 'partner=' + this.partner + '&account=' + this.account + '&database_connection_name=' + this.databaseConnectionName + '&database_name=' + this.databaseName + '&table_name=' + this.tableName).subscribe(response1 => {
                if (response1 && response1[0]) {
                    this.isDataDictionaryFound = true;
                    this.dataDictionaryData = response1[0];
                } else {
                    this.isDataDictionaryFound = false;
                }
                resolve('success');
            }, error => {
                resolve('failed');
                if (error) {
                    if (error.error) {
                        this.dataDictionaryError = error.error.message ? error.error.message : error.error;
                    } else {
                        this.dataDictionaryError = 'Oops!!! Something went wrong. Data Dictionary not found...';
                    }
                } else {
                    this.dataDictionaryError = 'Oops!!! Something went wrong. Data Dictionary not found...';
                }
            });
        });
    }

    getProperties(tableName, databaseName, databaseType, databaseConnectionName) {
        this.propertiesLoading = true;
        this.lineagePathDataLoading = true;
        const payload = {
            'databaseConnectionName': databaseConnectionName,
            'databaseObjects': ['columns', 'foreign_keys', 'references', 'triggers', 'indexes'],
            'databaseName': databaseName,
            'tableName': tableName

        };

        if (databaseType === 'csv') {
            this.tableProperties = false;
        }
        this.confPost.getEntireSchemaForPartnerDatabaseTable(this.partner, payload).subscribe(async response => {
            // loaderDialog.close();
            this.propertiesLoading = false;

            if (response) {
                const temp = {
                    tableName: tableName,
                    foreignKeys: response['foreignKeys'],
                    references: response['references'],
                    fields: response['columns']
                };
                this.lineagePathTable = temp;
                setTimeout(() => {
                    this.lineagePathDataLoading = false;
                }, 500);
                await this.getDataDictionaryData().then(resp => {
                    if (this.isDataDictionaryFound === false) {
                        this.newDataDictionaryPayload.database_connection_name = this.databaseConnectionName;
                        this.newDataDictionaryPayload.database_name = this.databaseName;
                        this.newDataDictionaryPayload.table_name = this.tableName;
                    }
                });
                if (response.hasOwnProperty('columns')) {
                    this.metaSchema = response['columns'];
                    if (this.isDataDictionaryFound === false) {
                        this.newDataDictionaryPayload.columns = response['columns'];
                    } else {
                        if (this.metaSchema && this.metaSchema.length === 0) {
                            this.dataDictionaryData.columns = [];
                        } else {
                            if (this.dataDictionaryData.columns && this.dataDictionaryData.columns.length > 0) {
                                for (const column of this.dataDictionaryData.columns) {
                                    for (const column1 of this.metaSchema) {
                                        if (column && column1) {
                                            if (column1['attributeName'] === column['attributeName']) {
                                                column1['description'] = column['description'];
                                            }
                                        }
                                    }
                                }
                                this.dataDictionaryData.columns = this.metaSchema;
                            }
                        }
                    }
                }
                if (response.hasOwnProperty('references')) {
                    this.references = response['references'];
                    if (this.isDataDictionaryFound === false) {
                        this.newDataDictionaryPayload.references = response['references'];
                    }
                }
                if (response.hasOwnProperty('foreignKeys')) {
                    this.foreignKeys = response['foreignKeys'];
                    if (this.isDataDictionaryFound === false) {
                        this.newDataDictionaryPayload.foreign_keys = response['foreignKeys'];
                    }
                }
                if (response.hasOwnProperty('indexes') && response['indexes'].length > 0) {
                    this.indexesTableKeySet = Object.keys(response['indexes'][0]);
                    this.indexesTable = response['indexes'];
                    /*if (this.isDataDictionaryFound === false) {
                        this.newDataDictionaryPayload.foreign_keys = response['foreignKeys'];
                    }*/
                }
                if (response.hasOwnProperty('triggers') && response['triggers'].length > 0) {
                    this.triggersTableKeySet = Object.keys(response['triggers'][0]);
                    this.triggersTable = response['triggers'];
                    /*if (this.isDataDictionaryFound === false) {
                        this.newDataDictionaryPayload.foreign_keys = response['foreignKeys'];
                    }*/
                }
                if (this.isDataDictionaryFound === false) {
                    this.dataDictionaryData = this.newDataDictionaryPayload;
                    this._service.addItem(this.newDataDictionaryPayload, 'v1', 'services', 'services', 'datadictionary').subscribe(response1 => {
                        if (response1 && response1.hasOwnProperty('upsertedId')) {
                            this.dataDictionaryId = response1['upsertedId'];
                        } else {
                            this.dataDictionaryError = 'Oops!!! Error while creating data dictionary... Please try again after sometime';
                        }
                    }, error => {
                        this.dataDictionaryError = 'Oops!!! Error while creating data dictionary... Please try again after sometime';
                    });
                } else {
                    this.dataDictionaryId = this.dataDictionaryData['id'];
                    delete this.dataDictionaryData['id'];
                    this.confPost.patchEntityData('services', 'services', 'v1', 'datadictionary', this.dataDictionaryId, this.dataDictionaryData).subscribe(response1 => {
                    });
                }
            }
        }, error => {
            this.propertiesLoading = false;
        });
    }

    updateDataDictionary() {
        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'datacatalog_dictionary_update_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
            const payloadToSend = {
                actions: response
            };
            this.dataCatalogListenerInstance.dataCatalogListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
            });
        });
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
        });
        if (this.dataDictionaryData.hasOwnProperty('id')) {
            delete this.dataDictionaryData['id'];
        }
        this.confPost.patchEntityData('services', 'services', 'v1', 'datadictionary', this.dataDictionaryId, this.dataDictionaryData).subscribe(response1 => {
            Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'datacatalog_dictionary_update_success', 'INFO', 200, 'OK', '', {
                dataDictionaryId: this.dataDictionaryId,
                dataDictionaryData: this.dataDictionaryData
            }, response1, this.router.url)).then(response => {
                const payloadToSend = {
                    actions: response
                };
                this.dataCatalogListenerInstance.dataCatalogListener.emit({
                    type: 'audit',
                    id: localStorage.getItem('IdOfSession'),
                    payload: payloadToSend
                });
            });
            loaderDialog.close();
            this.platform.openSnackBar('Data dictionary updated successfully', 'Success', {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }, error => {
            Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'datacatalog_dictionary_update_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), {
                dataDictionaryId: this.dataDictionaryId,
                dataDictionaryData: this.dataDictionaryData
            }, error, this.router.url)).then(response => {
                const payloadToSend = {
                    actions: response
                };
                this.dataCatalogListenerInstance.dataCatalogListener.emit({
                    type: 'audit',
                    id: localStorage.getItem('IdOfSession'),
                    payload: payloadToSend
                });
            });
            loaderDialog.close();
            this.platform.openSnackBar('Error while updating data dictionary. Please try again after sometime.', 'Error', {
                duration: 6000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    saveTableDescription(value) {
        this.dataDictionaryData.table_description = value;
    }

    saveDescription(attr, value) {
        attr.description = value;
    }

    updateTransformOptions() {
        if (this.transformOptionSelected === 'apionly') {
            this.dataMigration = false;
            this.targetDatabase = null;
        } else {
            this.dataMigration = true;
        }
    }

    validateDatabaseSelection(forIndividualtable = false) {
        this.databases.forEach(database => {
            if (database.database_name === this.targetDatabase) {
                this.targetDatabaseType = database.database_type;
            }
        });

        if (!forIndividualtable) {
            for (const table of this.tableResponse) {
                this.deploymentPlanToPost['tables'][table].targetDatabase = this.targetDatabase;
            }
        }

        if (this.targetDatabase === this.databaseName) {
            this.platform.openSnackBar('Source and Target Databases can not be same.', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }


    buildDeploymentPlanForDatabaseTransformation() {
        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'datacatalog_deployasapi_showdeploymentplan_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
            const payloadToSend = {
                actions: response
            };
            this.dataCatalogListenerInstance.dataCatalogListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
            });
        });
        this.loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
            data: {
                message: 'Kindly wait while preparing the deployment plan for database object(s). Please do not press back button or refresh the page.'
            }
        });
        this.loading1 = true;
        if (this.dataMigration) {
            if (this.MyForm1.valid) {
                this.showDeploymentPlanFlag = false;
                const requestModel = {
                    'sourceDatabaseName': this.databaseConnectionName,
                    'types': ['TABLE'],
                    'databaseObjects': this.listOfTables,
                    'transformOption': this.transformOptionSelected,
                    'targetDatabaseName': (this.transformOptionSelected !== 'apionly' ? this.targetDatabase : this.databaseConnectionName),
                    'useReferentialKey': this.useReferentialKeys,
                    'referentialKeyOption': this.referentialKeyOptionSelected,
                    'cascadeOnDelete': this.cascadeOnDelete,
                    'cascadeOnUpdate': this.cascadeOnUpdate
                };
                this.buildDeploymentPlanForTransformation(requestModel);
            } else {
                alert('Select atleast one Target Database');
                this.loading1 = false;
                this.loaderDialog.close();
            }
        } else {
            this.showDeploymentPlanFlag = false;
            const requestModel = {
                'sourceDatabaseName': this.databaseConnectionName,
                'types': ['TABLE'],
                'databaseObjects': this.listOfTables,
                'transformOption': this.transformOptionSelected,
                'targetDatabaseName': (this.transformOptionSelected !== 'apionly' ? this.targetDatabase : this.databaseConnectionName),
                'useReferentialKey': this.useReferentialKeys,
                'referentialKeyOption': this.referentialKeyOptionSelected,
                'cascadeOnDelete': this.cascadeOnDelete,
                'cascadeOnUpdate': this.cascadeOnUpdate
            };
            this.buildDeploymentPlanForTransformation(requestModel);
        }
    }

    buildDeploymentPlanForTransformation(requestModel) {
        this.buildDeploymentRetries += 1;
        if (this.buildDeploymentRetries <= 5) {
            this.confPost.buildDeploymentPlanForDatabaseTransformation(localStorage.getItem('partner'), localStorage.getItem('account'), requestModel).subscribe(data => {
                if (data && data['body']) {
                    this.deploymentPlan = data['body'];
                    if (this.deploymentPlan) {
                        this.apiExecutorPlans = this.deploymentPlan.executorModelDeploymentPlans;
                        this.entityPlans = this.deploymentPlan.entityDeploymentPlans;
                        let tableAttributes = {};
                        if (this.erTables && this.erTables.length) {
                            for (const table of this.erTables) {
                                tableAttributes[table['tableName']] = table['fields'];
                            }
                        }
                        for (let i = 0; i < this.deploymentPlan.entityDeploymentPlans.length; i++) {
                            if (this.deploymentPlanToPost && this.transformOptionSelected !== 'apionly') {
                                this.deploymentPlan.entityDeploymentPlans[i]['entity']['database'] = this.deploymentPlanToPost['tables'][this.deploymentPlan.entityDeploymentPlans[i]['entity'].tableName].targetDatabase;
                            }

                            if (tableAttributes && tableAttributes[this.deploymentPlan.entityDeploymentPlans[i]['entity'].entityname]) {
                                this.deploymentPlan.entityDeploymentPlans[i]['entity']['attributes'] = tableAttributes[this.deploymentPlan.entityDeploymentPlans[i]['entity'].entityname];
                            }
                        }
                        this.dataMigrationPlans = this.deploymentPlan.dataMigrationPlans;
                        for (const entity of this.entityPlans) {
                            entity['deploy_api'] = true;
                            if (entity.isAvailable) {
                                entity['deploy_api'] = false;
                            }
                            // entity['override_api'] = entity.isAvailable;
                        }
                        this.showNextPanel = true;
                        this.loading1 = false;
                        this.loaderDialog.close();
                    }
                }
            }, error => {
                setTimeout(() => {
                    this.buildDeploymentPlanForTransformation(requestModel);
                }, 6000);
            });
        } else {
            this.loading1 = false;
            this.loaderDialog.close();
            this.buildDeploymentRetries = 0;
            this.platform.openSnackBar('Oops!!! Something went wrong. Please try again after sometime.', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    filterDatabaseObjectTypes() {
        //this.getDatabaseTypeForDatabaseName(val);
        this.databaseObjectTypeFilter = [];
        this.databaseObjectTypes.filter(items => {
            if (items.database_type === this.selectedDatatypeFilter) {
                this.databaseObjectTypeFilter.push(items.database_object_types);
            }
        });
        // this.filteredDatabaseObjects = this.databaseObjectTypeFilter[0].database_object_types;
    }

    databaseObjectsSelected() {
    }

}

@Component({
    selector: 'deploy-as-api',
    templateUrl: 'deploy-as-api/deploy-as-api.component.html',
    styleUrls: ['deploy-as-api/deploy-as-api.component.css']
})
export class DeployAsAPIComponent implements OnInit {

    listofTables: any;
    listofViews: any;
    listofProcedures: any;
    listofIndexes: any;
    useReferentialKeys: boolean;
    databaseName: string;
    targetDatabase: any;
    databases: any;
    @ViewChild('myForm1', {static: false}) public MyForm1: NgForm;
    selectedDatatypeFilter: any;
    targetDatabaseType: any;
    transformOptionSelected: any;
    transformOptions = [
        {
            'name': 'Generate APIs Only - No Data Migration',
            'value': 'apionly'
        },
        {
            'name': 'Migrate Data Only - No API Generation',
            'value': 'dataonly'
        },
        {
            'name': 'Migrate Data & Generate APIs',
            'value': 'apiwithdata'
        }
    ];

    referentialKeyOptions = [
        // {'value': 'embed',
        //  'display_name': 'Embed child data with parent entity'},
        {
            'value': 'reference',
            'display_name': 'Seperate data and create reference'
        }
    ];
    referentialKeyOptionSelected = 'reference';

    dataMigration = false;
    deploymentPlan: any;
    apiExecutorPlans: any;
    entityPlans: any;
    dataMigrationPlans: any;
    showNextPanel = false;
    partner = localStorage.getItem('partner');
    account = localStorage.getItem('account');

    progress = 0;
    progressMessage: string;

    showDeploymentPlanFlag = true;
    cascadeOnDelete = true;
    cascadeOnUpdate = true;
    loading = false;
    loading1 = false;
    buildDeploymentRetries = 0;
    componentLoading = true;

    constructor(private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<DeployAsAPIComponent>, public confPost: ConfService, public router: Router, public kongService: KongService, public dataCatalogListenerInstance: DatacatalogListenerService) {
        dialogRef.disableClose = true;
    }

    async ngOnInit() {
        if (this.platform.databases === null || this.platform.databases === undefined || !this.platform.databases) {
            await this.platform.getDatabasesForPartnerAccount();
        }
        if (this.platform.databases === undefined || this.platform.databases === null) {
            this.close();
        }
        this.databases = this.platform.databases;
        if (this.data) {
            this.databaseName = this.data['databaseName'];
        }
    }

    updateTransformOptions() {
        if (this.transformOptionSelected === 'apionly') {
            this.dataMigration = false;
            this.targetDatabase = null;
        } else {
            this.dataMigration = true;
        }
    }

    validateDatabaseSelection() {
        this.databases.forEach(database => {
            if (database.database_name === this.targetDatabase) {
                this.targetDatabaseType = database.database_type;
            }
        });

        if (this.targetDatabase === this.databaseName) {
            this.platform.openSnackBar('Source and Target Databases can not be same.', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    buildDeploymentPlanForDatabaseTransformation() {
        this.loading1 = true;
        if (this.dataMigration) {
            if (this.MyForm1.valid) {
                this.showDeploymentPlanFlag = false;
                const requestModel = {
                    'sourceDatabaseName': this.data['databaseConnectionName'],
                    'types': ['TABLE'],
                    'databaseObjects': this.data['tableName'],
                    'transformOption': this.transformOptionSelected,
                    'targetDatabaseName': (this.transformOptionSelected !== 'apionly' ? this.targetDatabase : this.databaseName),
                    'useReferentialKey': this.useReferentialKeys,
                    'referentialKeyOption': this.referentialKeyOptionSelected,
                    'cascadeOnDelete': this.cascadeOnDelete,
                    'cascadeOnUpdate': this.cascadeOnUpdate
                };
                this.buildDeploymentPlanForTransformation(requestModel);
            } else {
                alert('Select atleast one Target Database');
                this.loading1 = false;
            }
        } else {
            this.showDeploymentPlanFlag = false;
            const requestModel = {
                'sourceDatabaseName': this.data['databaseConnectionName'],
                'types': ['TABLE'],
                'databaseObjects': this.data['tableName'],
                'transformOption': this.transformOptionSelected,
                'targetDatabaseName': (this.transformOptionSelected !== 'apionly' ? this.targetDatabase : this.databaseName),
                'useReferentialKey': this.useReferentialKeys,
                'referentialKeyOption': this.referentialKeyOptionSelected,
                'cascadeOnDelete': this.cascadeOnDelete,
                'cascadeOnUpdate': this.cascadeOnUpdate
            };
            this.buildDeploymentPlanForTransformation(requestModel);
        }
    }

    buildDeploymentPlanForTransformation(requestModel) {
        this.buildDeploymentRetries += 1;
        if (this.buildDeploymentRetries <= 5) {
            this.confPost.buildDeploymentPlanForDatabaseTransformation(localStorage.getItem('partner'), localStorage.getItem('account'), requestModel).subscribe(data => {
                if (data && data['body']) {
                    Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'datacatalog_deployasapi_showdeploymentplan_success', 'INFO', data.status, data.statusText, '', requestModel, data, this.router.url)).then(response => {
                        const payloadToSend = {
                            actions: response
                        };
                        this.dataCatalogListenerInstance.dataCatalogListener.emit({
                            type: 'audit',
                            id: localStorage.getItem('IdOfSession'),
                            payload: payloadToSend
                        });
                    });
                    this.deploymentPlan = data['body'];
                    if (this.deploymentPlan) {
                        this.apiExecutorPlans = this.deploymentPlan.executorModelDeploymentPlans;
                        this.entityPlans = this.deploymentPlan.entityDeploymentPlans;
                        this.dataMigrationPlans = this.deploymentPlan.dataMigrationPlans;
                        this.showNextPanel = true;
                        this.loading1 = false;
                    }
                }
            }, error => {
                Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'datacatalog_deployasapi_showdeploymentplan_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), requestModel, error, this.router.url)).then(response => {
                    const payloadToSend = {
                        actions: response
                    };
                    this.dataCatalogListenerInstance.dataCatalogListener.emit({
                        type: 'audit',
                        id: localStorage.getItem('IdOfSession'),
                        payload: payloadToSend
                    });
                });
                setTimeout(() => {
                    this.buildDeploymentPlanForTransformation(requestModel);
                }, 6000);
            });
        } else {
            this.loading1 = false;
            this.buildDeploymentRetries = 0;
            this.platform.openSnackBar('Oops!!! Something went wrong. Please try again after sometime.', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    close() {
        this.dialogRef.close();
    }
}

